module.exports = __webpack_public_path__ + "img/Managed_Service.df45779f.svg";